import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { QuotationFclDetail } from '@/class/model/price/QuotationFclDetail'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { multiply } from '@/utils/commonUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { PriceLclUtil } from '@/class/cargo/model/utils/PriceLclUtil'
import { PriceAirUtil } from '@/class/cargo/model/utils/PriceAirUtil'
import { QuotationLclDetail } from '@/class/model/price/QuotationLclDetail'
import { QuotationAirDetail } from '@/class/model/price/QuotationAirDetail'
import { Quotation } from '@/class/model/price/Quotation'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default class InquiryHp extends AbstractViewManage {
  constructor(view) {
    super(view)
  }

  buildQuotationBaseFromInquiry(inquiryForm) {
    const quotation = { ...(inquiryForm || {}) }
    quotation.grossWeight = quotation.grossWeight ?? quotation.weight
    quotation.cubage = quotation.cubage ?? 0
    if (!Array.isArray(quotation.seaEqList)) quotation.seaEqList = []
    for (const seaEq of quotation.seaEqList) {
      const seaEqObj = SystemConstants.SEA_EQ_TYPE_MAP.get(seaEq.type)
      if (!seaEqObj) continue
      const numField = seaEqObj.numField
      quotation[numField] = (Number(quotation[numField]) || 0) + (Number(seaEq.quantity) || 0)
    }
    return quotation
  }

  async loadQuotationChargeDetailByUuid(quotationUuid) {
    if (!quotationUuid) return []
    const jobModel = new Quotation({ uuid: quotationUuid })
    jobModel.quotationChargeDetail = ''
    await jobModel.loadQuotationRelated({ quotationChargeDetail: true })
    return jobModel.quotationChargeDetail || []
  }

  async remoteBooking(view) {
    const dataView = (this && this.view && this.view.form) ? this.view : view
    const form = dataView.form
    const selectedTrunkLineData = dataView.selectedTrunkLineData
    const selectedPrePortData = dataView.selectedPrePortData
    const selectedLastMileData = dataView.selectedLastMileData
    const quotations = dataView.quotations || view.quotations
    const getSelectedQuotation = (selectedData) => {
      if (!selectedData || !Array.isArray(quotations) || quotations.length === 0) return null
      if (selectedData.quotationUuid) {
        const byUuid = quotations.find(q => q && q.uuid === selectedData.quotationUuid)
        if (byUuid) return byUuid
      }
      if (selectedData.quotationNo) {
        return quotations.find(q => q && q.quotationNo === selectedData.quotationNo) || null
      }
      return null
    }
    const selectedTrunkLineQuotations = getSelectedQuotation(selectedTrunkLineData)
    const selectedPrePortQuotations = getSelectedQuotation(selectedPrePortData)
    const selectedLastMileQuotations = getSelectedQuotation(selectedLastMileData)

    let job
    // 业务类型
    if ([SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code, SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code].indexOf(form.type) > -1) {
      job = new SeaExportJob().fillDefaultValue().getData()
      job.lob = 'SE'
    } else if (SystemConstants.PRICE_INQUIRY_TYPE_AIR.code === form.type) {
      job = new AirExportJob().fillDefaultValue().getData()
      job.lob = 'AE'
    }
    // 询价单号
    job.inquiryPriceNo = form.inquiryPriceNo

    if (selectedTrunkLineQuotations) {
      job.quotationNo = selectedTrunkLineQuotations.quotationNo
      job.planner = selectedTrunkLineQuotations.solveUserId ? Number(selectedTrunkLineQuotations.solveUserId) : 0
      await JobUtils.txtPlannerChangeHandler({ userId: job.planner, value: job.planner }, job, view)
    }

    if (selectedPrePortQuotations) {
      // 关联港前报价单号
      job.prePortQuotationNo = selectedPrePortQuotations.quotationNo
      job.prePortPlanner = selectedPrePortQuotations.solveUserId ? Number(selectedPrePortQuotations.solveUserId) : 0
      await JobUtils.prePortPlannerChangeHandler({ userId: job.prePortPlanner, value: job.prePortPlanner }, job, view)
    }

    if (selectedLastMileData) {
      // 关联尾程报价单号
      job.lastMileQuotationNo = selectedLastMileData.quotationNo
      job.lastMilePlanner = selectedLastMileData.solveUserId ? Number(selectedLastMileData.solveUserId) : 0
      await JobUtils.lastMilePlannerChangeHandler({ userId: job.lastMilePlanner, value: job.lastMilePlanner }, job, view)
    }
    if (form.customerIdType === SystemConstants.CUSTOMER_ID_TYPE_OFFICIAL.code) {
      job.customerId = form.customerId ? Number(form.customerId) : 0
    }
    // 英文品名
    job.cargoEnglishName = form.cargoDescription
    if (selectedPrePortData) {
      // 支线时，是否驳船 改成 驳船，起运地区域带到 驳船pol
      if (selectedPrePortData.priceMethod === SystemConstants.PRICE_METHOD_BRANCH.code) {
        job.showBargeCustomCutoff = true
        job.bargePOL = form.provinceName + form.cityName + form.districtsName + form.townName
      }
      // 运输公司
      job.carryingCmp = selectedPrePortData.supplier
    }
    // 运价类型 取询价单上
    if (form.transportMode === SystemConstants.PRICE_METHOD_BRANCH.code) {
      job.rateType = SystemConstants.RATE_TYPE_FEEDER_SERVICE.code
    } else if (form.transportMode === SystemConstants.PRICE_METHOD_DIRECT.code) {
      job.rateType = SystemConstants.RATE_TYPE_DIRECT_TRANSPORT.code
    }
    job.loadingPortCode = form.pol
    job.dischargingPortCode = form.pod
    // 目的港代理
    if (selectedLastMileData) {
      job.destinationAgent = selectedLastMileData.agentName
    }
    if (selectedTrunkLineData) {
      // 免柜租期/免用箱
      job.freeTime = selectedTrunkLineData.freeTime || 0
      job.transfering = selectedTrunkLineData.direct === false
      if (job.transfering) {
        // 中转港 取 报价中
        job.transferPortCode = selectedTrunkLineData.via
      }
      // etd
      job.etd = selectedTrunkLineData.etd
      // 船公司
      job.carrierId = selectedTrunkLineData.carrier || 0
    }
    // 门点地址（truckinfo.address） 取询价中的详细地址
    // job.doorAddr = this.form.provinceName + this.form.cityName + this.form.districtsName + this.form.townName
    // 货物类型
    job.cargoType = form.cargoType
    // 贸易条款
    job.incoTerm = form.serviceTerm
    // 港前勾选
    if (form.prePortEnable) {
      // 客户门点勾选
      job.landTransportation = true
      job.inquiryPrice = form
    }
    // 销售公司
    job.salesOffice = form.salesOffice
    // 销售部门
    job.salesDepartment = form.salesDepartment
    job.weightContract = form.weight
    job.weightActual = form.weight
    // 生成箱子
    if (form && form.seaEqList && form.seaEqList.length > 0) {
      for (const seaEq of form.seaEqList) {
        const seaEqObj = SystemConstants.SEA_EQ_TYPE_MAP.get(seaEq.type)
        await this.getDistinctJobSeaEq(job, seaEqObj.eqSize, seaEqObj.eqType, seaEq.quantity)
      }
    }
    // 生成费用
    if (selectedTrunkLineData) {
      const quotation = selectedTrunkLineQuotations
      const quotationDetail = selectedTrunkLineData
      quotation.quotationChargeDetail = await this.loadQuotationChargeDetailByUuid(quotationDetail.quotationUuid)
      if (quotationDetail) {
        // 整箱 生成费用
        if (form.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
          // 生成应付费用(海运费)
          await BookingUtil.generateChargeByQuotationFCLFromInquiry(new QuotationFclDetail(quotationDetail), quotation, job, false)
          // 本地费用
          await BookingUtil.getQuotationChargeDetailFromInquiry(quotation, job, false, quotationDetail.source || 0, quotationDetail.prcCreatedBy)
        }
        // 拼箱 生成费用
        else if (form.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code) {
          // 生成应付费用(海运费) 应付已经排除掉 待确认 zrd todo
          await PriceLclUtil.generatingChargeLclFromInquiry(quotation, new QuotationLclDetail(quotationDetail), job)
          // 本地费用
          await BookingUtil.getQuotationChargeDetailFromInquiry(quotation, job, false, quotationDetail.source || 0, quotationDetail.prcCreatedBy)
        }
        // 空运 生成费用
        else if (form.type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code) {
          quotation.quotationAirDetail = new QuotationAirDetail(quotationDetail)
          // 生成应收费用(海运费) 需要么，待确认 zrd todo
          // await PriceAirUtil.generatingReceivableCharge(quotation, job)
          // 应付费用
          // zrd todo 费用创建人取 运价创建人
          await PriceAirUtil.generatingPayableCharge(quotation, job)
          // 结算对象 统一取 运价来源
          if (job.charges && job.charges.length > 0) {
            job.charges.forEach(p => { p.accountId = quotationDetail.source || 0 })
          }
        }
      }
    }

    if (selectedPrePortData) {
      await BookingUtil.generateChargeByQuotationDetail(selectedPrePortData, form, job, selectedPrePortQuotations)
      job.selectedPrePortData = selectedPrePortData
    }

    if (selectedLastMileData) {
      await BookingUtil.generateChargeByQuotationDetail(selectedLastMileData, form, job, selectedLastMileQuotations)
    }

    // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        if (charge.taxRate && charge.taxRate > 0) {
          continue
        }
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        charge.taxRate = chargeItem ? (chargeItem.taxRate || 0) : 0
        if (charge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(charge, multiply(charge.unitRate, charge.quantity), charge.taxRate)
        } else {
          ChargeUtils.calculateTax(charge, multiply(charge.unitRate, charge.quantity), charge.taxRate)
        }
        // CARGO-31003 在新增费用时，直接对特定的费用进行受控
        charge.controlled = chargeItem?.controlled
        charge.needInvoice = chargeItem?.needInvoice
      }
    }
    job.priceSource = PriceConstant.PRICE_SOURCE_INQUIRY
    console.log('job.charge', job.charges)
    view.$router.push({
      name: 'RemoteBooking',
      params: {
        view: 'detail',
        action: 'add',
        job
      }
    })
  }

  /**
   * 箱型箱量
   */
  getDistinctJobSeaEq(job, eqSize, eqType, eqQuantity) {
    const seqEq = new SeaEQ().fillDefaultValue().getData()
    seqEq.jobUuid = job.uuid
    seqEq.eqSize = eqSize// 箱型
    seqEq.eqType = eqType// 箱种
    seqEq.eqQuantity = eqQuantity// 箱量
    if (!job.seaEQ || job.seaEQ.length <= 0) {
      job.seaEQ = []
      job.seaEQ.push(seqEq)
    } else {
      const row = job.seaEQ.find(p => p.eqSize === seqEq.eqSize && p.eqType === seqEq.eqType)
      if (!row) {
        job.seaEQ.push(seqEq)
      }
    }
  }
}
